import React from "react";
import { toast } from "react-toastify";

export const ShowToastError = (props) => {
  if (!props || !props.error) {
    toast.error("Something went wrong. Please try again later.");
    return null;
  }

  const { error } = props;

  let content = "Something went wrong. Please try again later.";
  if (error?.response?.data?.detail) {
    content = (
      <div>
        <strong>#{error.response.data.detail.error_code}</strong>&nbsp;&nbsp;
        {error.response.data.detail.masked_error}
      </div>
    );
  }
  // else if (error?.message) {
  //   content = error.message;
  // }

  toast.error(content);
  return null;
};
